import { Link } from "react-router-dom";

function Footer() {
  return (
    <section className="landing-footer">
      <footer>
        <div className="footer-logo">
          {/* <img src={require("./img/mocean-logo-full-dark.png")} alt="" /> */}
          <h2>Mocean</h2>
          <p>
            Send SMS messages quickly and easily. Manage your campaigns, track
            deliveries, and connect with your audience anytime, anywhere.
          </p>
          <div className="footer-socials">
            <ul>
              <li>
                <img src={require("../img/icon_teams.png")} alt="" />
                <a href="https://www.microsoft.com/en-my/microsoft-teams/log-in">
                  mocean.support (MS Teams)
                </a>
              </li>
              <li>
                <img src={require("../img/icon_wa2.png")} alt="" />
                <a href="https://wa.me/60173788399">wa.me/60173788399</a>
              </li>
              <li>
                <img src={require("../img/icon_mail.png")} alt="" />
                <a href="mailto:sales@moceansms.com">sales@moceansms.com</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="footer-links">
          <ul>
            <h3>Documents</h3>
            <li>
              <Link to="https://moceanapi.com/docs/#sms-api/">SMS API</Link>
            </li>
            <li>
              <Link to="https://moceanapi.com/docs/#whatsapp-api/">
                WhatsApp API
              </Link>
            </li>
            <li>
              <Link to="https://moceanapi.com/docs/#voice-api/">Voice API</Link>
            </li>
            <li>
              <Link to="https://moceanapi.com/docs/#verify-api/">
                Verify API
              </Link>
            </li>
            <li>
              <Link to="https://moceanapi.com/docs/#number-lookup-api/">
                Number Lookup API
              </Link>
            </li>
            <li>
              <Link to="https://moceanapi.com/developer/libraries">
                SDK & Libraries
              </Link>
            </li>
            <li>
              <Link to="https://moceanapi.com/developer/libraries">Tools</Link>
            </li>
          </ul>
          <ul>
            <h3>Company</h3>
            <li>
              <Link to="https://moceanapi.com/about-us/">About Us</Link>
            </li>
            <li>
              <a href="#contact-us">Contact Us</a>
            </li>
            <li>
              <Link to="https://dashboard.moceanapi.com/login/">Login</Link>
            </li>
            <li>
              <Link to="https://dashboard.moceanapi.com/register/">
                Sign up
              </Link>
            </li>
          </ul>
          <ul>
            <h3>Legal</h3>
            <li>
              <a href="https://moceanapi.com/legal/terms">
                Terms and Conditions
              </a>
            </li>
            <li>
              <Link to="https://moceanapi.com/legal/privacy">Privacy</Link>
            </li>
            <li>
              <Link to="https://moceanapi.com/legal/refund-policy">
                Refund Policy
              </Link>
            </li>
            <li>
              <Link to="https://www.paypal.com/ie/legalhub/paypal/acceptableuse-full">
                Paypal Acceptable
              </Link>
            </li>
          </ul>
        </div>
        <div className="footer-legal">
          <p>2025 © Micro Ocean Technologies Sdn. Bhd.</p>
        </div>
      </footer>
    </section>
  );
}

export default Footer;
